import { ChevronRight } from 'lucide-react';

interface NewsSectionProps {
    onOpenOSPTutor?: () => void;
}

const NewsSection: React.FC<NewsSectionProps> = ({ onOpenOSPTutor }) => {
    return (
        <div className="h-full bg-gradient-to-br from-violet-600 to-indigo-700 dark:from-violet-700 dark:to-indigo-800 rounded-3xl p-6 flex flex-col relative overflow-hidden shadow-[0_4px_12px_rgba(0,0,0,0.15)] dark:shadow-none">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-36 h-36 bg-white/10 rounded-full -mr-10 -mt-10 blur-2xl"></div>
            <div className="absolute bottom-0 left-0 w-28 h-28 bg-indigo-400/15 rounded-full -ml-8 -mb-8 blur-2xl"></div>

            {/* Floating dots & shapes */}
            <div className="absolute top-[45%] left-[15%] w-3 h-3 bg-white/20 rounded-full"></div>
            <div className="absolute top-[35%] right-[20%] w-2 h-2 bg-violet-300/30 rounded-full"></div>
            <div className="absolute top-[60%] right-[35%] w-4 h-4 bg-white/10 rounded-full blur-[1px]"></div>
            <div className="absolute top-[55%] left-[40%] w-2.5 h-2.5 bg-indigo-300/25 rounded-full"></div>
            <div className="absolute top-[40%] left-[60%] w-1.5 h-1.5 bg-white/30 rounded-full"></div>
            <div className="absolute top-[70%] left-[25%] w-2 h-2 bg-violet-200/20 rounded-full"></div>

            {/* Sparkle star SVGs */}
            <svg className="absolute top-[42%] right-[15%] w-5 h-5 text-white/15" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0L14.59 8.41L23 12L14.59 15.59L12 24L9.41 15.59L1 12L9.41 8.41Z" />
            </svg>
            <svg className="absolute top-[58%] left-[20%] w-4 h-4 text-white/10" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0L14.59 8.41L23 12L14.59 15.59L12 24L9.41 15.59L1 12L9.41 8.41Z" />
            </svg>
            <svg className="absolute top-[48%] left-[50%] w-6 h-6 text-violet-300/10" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0L14.59 8.41L23 12L14.59 15.59L12 24L9.41 15.59L1 12L9.41 8.41Z" />
            </svg>

            {/* Subtle ring */}
            <div className="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 w-24 h-24 rounded-full border border-white/5"></div>
            <div className="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 w-40 h-40 rounded-full border border-white/[0.03]"></div>

            <div className="relative z-10 flex flex-col h-full justify-between">
                <div>
                    <h2 className="text-2xl font-bold font-poppins mb-1.5 text-white leading-tight">OSP Modul</h2>
                    <p className="text-sm text-violet-100/80 leading-relaxed">
                        Trénuj s AI tutorem a procvičuj úlohy z verbálního i analytického oddílu.
                    </p>
                </div>

                <div className="mt-5">
                    <button
                        onClick={onOpenOSPTutor}
                        className="w-full bg-white text-violet-700 font-bold font-poppins py-3 px-4 rounded-xl shadow-lg border-b-[6px] border-violet-200 active:border-b-2 active:translate-y-[4px] transition-all flex items-center justify-center gap-2 group hover:shadow-xl hover:bg-violet-50"
                    >
                        <span>Přejít do OSP modulu</span>
                        <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewsSection;
